import { jsx as _jsx } from "react/jsx-runtime";
import { SIcon } from "./components";
export const SSegmentedControl = ({ options, iconSize = 15, value, height = 32, onChange })=>{
    return /*#__PURE__*/ _jsx("div", {
        style: {
            height: `${height}px`
        },
        className: "bg-grayscale-dark rounded-md border border-white/10 items-center overflow-hidden cursor-pointer group transition relative grid grid-flow-col auto-cols-max px-[4px]",
        children: options.map((option, index)=>/*#__PURE__*/ _jsx("div", {
                onClick: ()=>onChange(option),
                style: {
                    height: `${height - 2}px`
                },
                className: `!cursor-pointer transition ${option.icon ? "w-[24px] hover:scale-[1.05]" : typeof option.label === "string" ? "px-[6px] text-[13px]" : ""} flex items-center justify-center ${value?.value === option.value ? "text-brand-primary" : "text-white/40 hover:text-white/100 active:scale-[0.95]"}`,
                children: option.icon ? /*#__PURE__*/ _jsx(SIcon, {
                    type: option.icon,
                    className: "",
                    size: iconSize
                }) : option.label
            }, option.icon || option.label || index))
    });
};
